import React from 'react';
import { PauseCircle } from 'lucide-react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

/**
 * Shown in place of the real workspace, on a direct URL to either Sales
 * Invoicing or Invoice List, while the module is paused. Preservation of
 * data is stated explicitly so a direct visitor never has to guess.
 */
export function SalesInvoicingPausedNotice({ pausedMessage }) {
  return (
    <Alert data-testid="sales-invoicing-paused-notice" className="border-amber-300 bg-amber-50 text-amber-900">
      <PauseCircle className="h-5 w-5 text-amber-600" />
      <AlertTitle>Sales Invoicing is paused</AlertTitle>
      <AlertDescription>
        {pausedMessage || 'Sales Invoicing is temporarily paused. All existing records, mappings, export and audit history, and the stored QuickBooks connection are preserved — nothing is deleted or changed while paused.'}
      </AlertDescription>
    </Alert>
  );
}
